export type StoreProductCardHeadingFields = {
    instName: string | null | undefined;
    productName: string | null | undefined;
    gradSchoolId: number | null | undefined;
    gsName: string | null | undefined;
};

export function formatStoreProductCardHeading({instName, productName, gradSchoolId, gsName}: StoreProductCardHeadingFields): string {
    const institution = instName ?? '';
    const product = productName ?? '';
    const graduateSchoolName = (gradSchoolId ?? 0) > 0 ? (gsName?.trim() ?? '') : '';

    if (graduateSchoolName) {
        return `${institution} - ${graduateSchoolName} - ${product}`;
    }

    return `${institution} - ${product}`;
}
